import { CampoAlterado, DadosRecusaProfissional } from "./types";
import api from "../../../../../../../services/api";
import { parseJsonSafely } from "../../../../../../../utility/jsonUtils";
import { getStatusLabelDemanda } from "../../../../../../../utility/statusDemanda";

const formatValue = (value: any): string => {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
};

const formatarNomeProfissional = async (id_usuario: number | null | undefined, nomeDisponivel?: string): Promise<string> => {
    try {
        if (!id_usuario || id_usuario === 0) {
            return "—";
        }
        
        const id = Number(id_usuario);
        if (isNaN(id) || id <= 0) {
            return "—";
        }
        
        if (nomeDisponivel) {
            return `${nomeDisponivel} (D${id})`;
        }
        
        try {
            const response = await api.get(`usuario/${id}`);
            if (response?.data?.status === 'success' && response?.data?.result?.nome) {
                return `${response.data.result.nome} (D${id})`;
            }
        } catch (error: any) {
            if (error?.response?.status && error.response.status !== 404) {
                return `D${id}`;
            }
        }
        
        return `D${id}`;
    } catch {
        return `D${id_usuario}`;
    }
};

export const mapearCamposAlterados = async (logProposta: any, dadosExtra?: any): Promise<CampoAlterado[]> => {
    try {
        if (!logProposta) return [];

        const dadosAntes = parseJsonSafely(logProposta.dados_antes) || {};
        const dadosDepois = parseJsonSafely(logProposta.dados_depois);
        const extra = parseJsonSafely(dadosExtra);

        if (!dadosDepois) return [];

        const campos: CampoAlterado[] = [];

        if (dadosDepois?.status && dadosAntes?.status !== dadosDepois.status) {
            campos.push({
                campo: 'Status',
                antes: getStatusLabelDemanda(dadosAntes?.status || 'Pendente'),
                depois: getStatusLabelDemanda(dadosDepois.status)
            });
        }

        if (dadosDepois?.id_usuario !== undefined) {
            const idAntes = dadosAntes?.id_usuario;
            const idDepois = dadosDepois.id_usuario;
            
            let antesTexto: string = '—';
            if (idAntes) {
                const idAntesNum = Number(idAntes);
                if (!isNaN(idAntesNum) && idAntesNum > 0) {
                    const profissionalAnterior = extra?.profissional_anterior;
                    const nomeAntes = profissionalAnterior?.nome;
                    antesTexto = await formatarNomeProfissional(idAntesNum, nomeAntes);
                }
            }
            
            let depoisTexto: string = '—';
            if (idDepois) {
                const idDepoisNum = Number(idDepois);
                if (!isNaN(idDepoisNum) && idDepoisNum > 0) {
                    const nomeDepois = extra?.nome_usuario;
                    depoisTexto = await formatarNomeProfissional(idDepoisNum, nomeDepois);
                }
            }

            campos.push({
                campo: 'Profissional Vinculado',
                antes: antesTexto,
                depois: depoisTexto
            });
        }

        return campos;
    } catch (error) {
        return [];
    }
};

export const mapearDadosRecusaProfissional = (logRecusa: any, dadosExtra?: any): DadosRecusaProfissional | null => {
    if (!logRecusa) return null;

    const dadosAntes = parseJsonSafely(logRecusa.dados_antes);
    const dadosDepois = parseJsonSafely(logRecusa.dados_depois);
    const extra = parseJsonSafely(dadosExtra);

    if (!dadosDepois) return null;

    const idUsuario = dadosDepois.id_usuario || dadosDepois.id_profissional;
    const nomeProfissional = extra?.nome_usuario || dadosDepois.nome || dadosDepois.nome_profissional || dadosDepois.nome_usuario;

    return {
        justificativa: dadosDepois.justificativa || "",
        id_usuario: idUsuario,
        nome_profissional: nomeProfissional,
        criado: dadosDepois.criado || dadosDepois.modificado,
        dados_antes: dadosAntes,
        dados_depois: dadosDepois
    };
};

export const formatarDataHora = (valor?: string): string => {
    if (!valor) return "—";
    try {
        const date = new Date(valor);
        if (isNaN(date.getTime())) return "—";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    } catch {
        return "—";
    }
};

